import { DeviceHardwareType } from "#/types/device";

/**
 * What a reader's hardware type is called in the UI, everywhere (customers and
 * TMA admin): the model only, never the manufacturer. Unknown or missing types
 * render as the given fallback.
 */
const HARDWARE_LABELS: Record<DeviceHardwareType, string> = {
  [DeviceHardwareType.CHAINWAY_C72]: "C72",
  [DeviceHardwareType.CHAINWAY_U300]: "U300",
  [DeviceHardwareType.SGS_RPI]: "RPI",
};

export const getHardwareLabel = (
  hardwareType: DeviceHardwareType | string | null | undefined,
  fallback = "--",
): string => {
  if (typeof hardwareType !== "string" || hardwareType.trim() === "") return fallback;
  const known = (Object.values(DeviceHardwareType) as string[]).includes(hardwareType)
    ? HARDWARE_LABELS[hardwareType as DeviceHardwareType]
    : undefined;
  // A type the web does not know yet: strip the manufacturer prefix rather than show it.
  return known ?? hardwareType.replace(/^chainway_/i, "").toUpperCase();
};
